import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=6088a500&scoped=true"
import script from "./editPassword.vue?vue&type=script&lang=js"
export * from "./editPassword.vue?vue&type=script&lang=js"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=6088a500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6088a500",
  null
  
)

export default component.exports